export default __webpack_public_path__ + "static/media/commercial.16e85c1c.jpeg";